import React from "react";
import "./blog.css";

function Blog(props) {
  return <div></div>;
}

export default Blog;
